import { useState } from 'react'

export const NavMenu = () => {
  const [isOpen, setIsOpen] = useState(false)

  const navigate = section => {
    const elementId = section + '-element'
    const element = document.getElementById(elementId)
    const offSet = window.innerWidth > 750 ? 40 : 30
    const bodyRect = document.body.getBoundingClientRect().top
    const elementRect = element.getBoundingClientRect().top
    const elementPosition = elementRect - bodyRect
    const offsetPosition = elementPosition - offSet

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    })
    setIsOpen(false)
  }
  return (
    <div className="nav-menu-wide">
      <div
        className={`nav-menu-hamburger ${isOpen && "nav-menu-hamburger-open"}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={`nav-menu ${isOpen && "nav-menu-open"}`}>
        {["home", "about", "skills", "projects", "algorithms", "contact"].map((sectionName, index) =>
          <div
            className={`nav-menu-block ${index === 0 && "nav-menu-block-first"}`}
            key={index}
            onClick={() => navigate(sectionName)}
          >
            <div className="nav-menu-text">
              {sectionName.toUpperCase()}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
